'use client'

import React, { useEffect } from 'react'
import { pushAdSlot } from '@/lib/ads/AdAlliance/AdAlliance.lib'

export type DefaultAdSlotProps = {
  id: string
  view: 'mobile' | 'desktop' | 'default'
}

export const DefaultAdSlot: React.FC<DefaultAdSlotProps> = ({ id, view }) => {
  useEffect(() => {
    pushAdSlot(id)
  })

  return (
    <div
      data-cy={`default-ad-slot_${id}`}
      id={id}
      data-ada-container={`${id}_${view}`}
      data-device={view}
    ></div>
  )
}
